<template>
  <div>
    <v-card>
      <v-card-title v-if="this.formaction == 'create'">
        <span class="headline">Add Email Template</span>
      </v-card-title>
      <v-card-title v-if="this.formaction == 'edit'">
        <span class="headline">Edit Email Template</span>
      </v-card-title>

      <v-card-text>
        <small>*indicates required field</small>

        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs4>
              <v-select
                v-model="Form.portalID"
                :items="portallist"
                item-text="portalName"
                item-value="id"
                chips
                multiple
                label="Portals"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="Form.templateID"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="emailTemplateForm"
                :error-messages="errors.collect('emailTemplateForm.templateID')"
                hide-details
                :counter="50"
                label="Template ID*"
                name="templateID"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="Form.type"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="emailTemplateForm"
                :error-messages="errors.collect('emailTemplateForm.type')"
                hide-details
                :counter="50"
                label="Type*"
                name="type"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="Form.name"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="emailTemplateForm"
                :error-messages="errors.collect('emailTemplateForm.name')"
                hide-details
                :counter="50"
                label="Name*"
                name="name"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="Form.description"
                :counter="50"
                label="Description"
                name="description"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="Form.fromEmail"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="emailTemplateForm"
                :error-messages="errors.collect('emailTemplateForm.fromEmail')"
                hide-details
                :counter="50"
                label="From Email*"
                name="fromEmail"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="Form.toEmail"                
                :counter="50"
                label="To Email"
                name="toEmail"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="Form.functionURL"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="emailTemplateForm"
                :error-messages="errors.collect('emailTemplateForm.functionURL')"
                hide-details
                :counter="50"
                label="Function URL*"
                name="functionURL"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="Form.redirectURL"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="emailTemplateForm"
                :error-messages="errors.collect('emailTemplateForm.redirectURL')"
                hide-details
                :counter="50"
                label="Redirect URL*"
                name="redirectURL"
              />
            </v-flex>
            <v-flex xs12 class="input-container">
              <span v-if="Form.enabled" style="padding-top: 25px;">Enabled</span>
              <span v-else style="padding-top: 25px;">Disabled</span>
              <v-switch v-model="Form.enabled" style="padding-left: 15px;"></v-switch>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="CloseDialog()">Close</v-btn>
        <v-btn color="blue darken-1" flat @click.native="SaveDocument('emailTemplateForm')">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>

export default {
  props: {
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    portal: {
      type: Object,
      default() {
        return {};
      }
    },
    form: {
      type: Object,
      default() {
        return {};
      }
    },
    formaction: {
      type: String,
      default: ""
    },
    portallist: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data: () => ({
    Form: {
      id: null,
      portalID: [],
      enabled: false,
      templateID: null,
      type: null,
      fromEmai: null,
      description: null,
      name: null,
      toEmail: null,
      functionURL: null,
      redirectURL: null
    }
  }),
  mounted() {
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
  },
  watch: {
    form() {
      this.Form = this.form;
    }
  },
  methods: {
    CloseDialog() {
      this.$emit("Dialog", false);
    },
    SaveDocument(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (!valid) {
          // do nothing
        } else {
          //console.log("Save Document + " + this.formaction);
          switch (this.formaction) {
            case "create":
              this.$store.dispatch("Admin/createDocument", [
                this.admin.Collection,
                this.Form,
                "Admin/setDocumentResult"
              ]);
              break;
            case "edit":
              var id = this.Form.id;
              // console.log(JSON.stringify(this.Form, null, 2));
              this.Form = this.$omit(this.Form, [
                "vgt_id",
                "originalIndex",
                "id"
              ]);
              // console.log(JSON.stringify(this.Form, null, 2));
              this.$store.dispatch("Admin/updateDocument", [
                this.admin.Collection,
                id,
                this.Form
              ]);
              break;
            default:
              break;
          }
          this.CloseDialog();
        }
      });
    }
  }
};
</script>

<style>
.input-container {
  vertical-align: middle !important;
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}
</style>